var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("b-form-input", {
    attrs: { type: "search", placeholder: "Search", debounce: "300" },
    model: {
      value: _vm.searchText,
      callback: function ($$v) {
        _vm.searchText = $$v
      },
      expression: "searchText",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }